import { useEffect, useRef, useState, type ReactNode } from "react";

/** One set of data/actions: a table on desktop, labelled stacked rows on phones. */
export function ResponsiveTable({ label, children }: { label: string; children: ReactNode }) {
  const region = useRef<HTMLDivElement>(null);
  const [scrollable, setScrollable] = useState(false);
  useEffect(() => {
    const element = region.current!;
    const update = () => setScrollable(element.scrollWidth > element.clientWidth + 1);
    const observer = new ResizeObserver(update);
    observer.observe(element);
    observer.observe(element.firstElementChild!);
    update();
    return () => observer.disconnect();
  }, [children]);
  return <div className="table-region" ref={region} role="region" aria-label={label} tabIndex={scrollable ? 0 : undefined}>
    <table className="table responsive-table" role="table" aria-label={label}>{children}</table>
  </div>;
}

export function ResponsiveCell({ label, className = "", children }: { label: string; className?: string; children: ReactNode }) {
  return <td role="cell" data-label={label}>
    <span className="table__cell-label" aria-hidden="true">{label}</span>
    <div className={`table__cell-value ${className}`}>{children}</div>
  </td>;
}
